'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InviteAFriendModal = exports.InviteAFriendModalUnwrapped = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Modal = require('decorators/Modal/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InviteAFriendModalUnwrapped = exports.InviteAFriendModalUnwrapped = function (_React$Component) {
  (0, _inherits3.default)(InviteAFriendModalUnwrapped, _React$Component);

  function InviteAFriendModalUnwrapped(props) {
    (0, _classCallCheck3.default)(this, InviteAFriendModalUnwrapped);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (InviteAFriendModalUnwrapped.__proto__ || (0, _getPrototypeOf2.default)(InviteAFriendModalUnwrapped)).call(this, props));

    _this2.state = {
      loaded: false
    };
    return _this2;
  }

  (0, _createClass3.default)(InviteAFriendModalUnwrapped, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.handleMessage = this.handleMessage.bind(this);
      window.addEventListener('message', this.handleMessage);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (__CLIENT__ || __TEST__) {
        window.removeEventListener('message', this.handleMessage);
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage(event) {
      var eventName = event.data.eventName;


      if (eventName === 'referralIframe:close' || eventName === 'referralIframe:done') {
        this.props.onModalClose();
      } else if (eventName === 'referralIframe:loaded') {
        this.setState({ loaded: true });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this = this;

      var _props = this.props,
          eventSource = _props.eventSource,
          reservationId = _props.reservationId;
      var loaded = this.state.loaded;


      return _react2.default.createElement(
        'div',
        null,
        !loaded && _react2.default.createElement(
          'div',
          { className: 'preloader__wrapper' },
          _react2.default.createElement('div', { className: 'preloader' })
        ),
        _react2.default.createElement('iframe', {
          src: '/referral_campaign/' + reservationId + (eventSource ? '?event_source=' + encodeURIComponent(eventSource) : ''),
          scrolling: 'no',
          className: 'modal__iframe',
          style: {
            display: loaded ? 'block' : 'none'
          },
          ref: function ref(ifr) {
            return _this.iframe = ifr;
          }
        })
      );
    }
  }]);
  return InviteAFriendModalUnwrapped;
}(_react2.default.Component);

InviteAFriendModalUnwrapped.propTypes = {
  eventSource: _propTypes2.default.string,
  reservationId: _propTypes2.default.number.isRequired,
  onModalClose: _propTypes2.default.func.isRequired
};

var InviteAFriendModal = exports.InviteAFriendModal = (0, _Modal2.default)({ headerClass: 'modal--iframe' })(InviteAFriendModalUnwrapped);